import { Link } from "react-router-dom";
import { ArrowUpRight, Rocket } from "lucide-react";
import { BOOKING_URL } from "@/lib/api";
import { Container, Reveal, GlowOrb, goldBtn, ghostBtn } from "@/components/kit";
import { cn } from "@/lib/utils";

export const CtaBand = ({
  eyebrow = "Ready when you are",
  title = "Stop paying for activity.",
  titleAccent = "Start paying for outcomes.",
  subtitle = "Book a discovery call and we'll map your ICP, model your pipeline, and show you exactly what a qualified meeting is worth.",
}) => (
  <section data-testid="cta-band" className="relative overflow-hidden py-24 md:py-28">
    <GlowOrb className="left-1/2 top-1/2 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 opacity-90" />
    <div className="absolute inset-0 -z-10 bg-navy-800/40" />
    <Container>
      <Reveal className="relative mx-auto max-w-4xl overflow-hidden rounded-[2rem] border border-gold/20 bg-navy-800/60 p-10 md:p-16 text-center shadow-[0_0_80px_rgba(255,215,0,0.08)]">
        <div className="mx-auto mb-7 flex h-14 w-14 items-center justify-center rounded-2xl bg-gold/10 border border-gold/30">
          <Rocket className="h-6 w-6 text-gold" />
        </div>
        <p className="font-mono-jb text-xs md:text-sm tracking-[0.28em] uppercase text-gold/80">
          {eyebrow}
        </p>
        <h2 className="mt-5 font-display text-3xl md:text-5xl font-medium tracking-tight text-white">
          {title}
          <br />
          <span className="text-gold text-glow-gold">{titleAccent}</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-white/65 text-base md:text-lg leading-relaxed">
          {subtitle}
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-band-book"
            className={goldBtn}
          >
            Book A Discovery Call
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <Link to="/contact" data-testid="cta-band-launch" className={ghostBtn}>
            Launch Your Outbound Campaign
          </Link>
        </div>
      </Reveal>
    </Container>
  </section>
);
